// export function uuid() {
//   return Math.random().toString(16).slice(2)
// }

// export function numberID() {
//   return parseInt(Math.random() * 100)
// }
'use strict'

const getRandomArbitrary = (min, max) => {
  return Math.random() * (max - min) + min
}

const calculateOrder = (previousOrder, nextOrder) => {
  const next = parseFloat(nextOrder)
  const previous = parseFloat(previousOrder)
  // if between elements
  if (nextOrder && previousOrder) {
    return getRandomArbitrary(previous, next).toFixed(10)
  }
  // if no previous element
  else if (!previousOrder) {
    return getRandomArbitrary(1, next).toFixed(10)
  }
  // if no next element
  else if (!nextOrder) {
    const max = parseInt(previous) + 1
    return getRandomArbitrary(previous, max).toFixed(10)
  }
}

const formatTitle = (title) => {
  return title
    .trim()
    .toLowerCase()
    .split(' ')
    .join('-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

const ToNextElementOrder = (order) => {
  if (!order) return (1).toFixed(10)
  let toConvert = (parseFloat(order) * 100) / 100
  toConvert = (toConvert + 1).toFixed(10)
  return toConvert
}

const checkArray = (array) => {
  return Array.isArray(array) && array.length > 0 ? true : false
}

const removeArrayDuplicates = (arr1, arr2, key, value) => {
  return arr1?.filter((key) => {
    if (!arr2.some((u) => u[value] == key[value])) return key
  })
}

const arraySortByObjectKey = (array, key) => {
  const toSort = Object.assign([], array)
  return toSort.sort((a, b) => a[key] - b[key])
}

const sortArrayByObjectKey = (array, objectPath, inverted = false) => {
  const compare = (a, b) => {
    let itemA, itemB

    if (objectPath instanceof Array) {
      // array of keys as object path was passed
      let result

      const loopIntoKeys = (object, path) => {
        if (path.length > 0) {
          const currentPath = path[0]
          const newPath = path.filter((p) => p !== currentPath)
          if (object[path[0]]) {
            result = object[currentPath]
            // console.log(currentPath, newPath)
          } else if (!object[path[0]]) {
            result = 'not-found'
          }

          loopIntoKeys(result, newPath)
        }
        return result
      }
      // console.log(loopIntoKeys(a, key))
      itemA = loopIntoKeys(a, objectPath)?.toUpperCase()
      itemB = loopIntoKeys(b, objectPath)?.toUpperCase()
    } else {
      itemA = a[objectPath].toUpperCase()
      itemB = b[objectPath].toUpperCase()
    }

    let comparison = 0
    if (itemA > itemB) {
      comparison = 1
    } else if (itemA < itemB) {
      comparison = -1
    }

    return inverted ? comparison * -1 : comparison
  }

  return array.sort(compare)
}

const objectHasPropertyValue = (obj, property) => {
  if (Object.prototype.hasOwnProperty.call(obj, property)) {
    return obj[property].trim() !== ''
  } else {
    return true
  }
}

const getComputedStyles = (element, style) => {
  return window.getComputedStyle(element).getPropertyValue(style)
}

// const appRegex = {
//   link: /\[(.+)\]\((https?:\/\/[^\s]+)(?: "(.+)")?\)|(https?:\/\/[^\s]+)/,
// }

const filterCards = (cards, options) => {
  return cards.filter((card) => card[options.key] === options.filter)
}

const filterCardsByStatus = (cards, status) => {
  if (checkArray(status)) {
    let filteredCards = []

    for (let value of status) {
      filteredCards.push(cards.filter((card) => card.status === value))
    }
    return filteredCards.flat()
  } else {
    console.log(`filterCardsByStatus: expected an 'array' got: '${typeof status}'`)
  }
}

const setDriveFolder = (folderId) => {
  const driveFolderBaseUrl = 'https://drive.google.com/drive/folders/'

  return driveFolderBaseUrl + folderId
}

const filterElementsByQuery = (query, elements, elementKey) => {
  const filterQuery = query.toLowerCase()

  if (filterQuery) {
    return elements.filter((element) => element[elementKey].toLowerCase().includes(filterQuery))
  } else {
    return elements
  }
}

const getSlotClass = (cardSlots) => {
  let className = ''
  switch (cardSlots) {
    case 2:
      className = 'two-slots'
      break
    case 3:
      className = 'three-slots'
      break
  }
  return className
}

const getPackIcon = (packName) => {
  let packIcon
  switch (packName) {
    case 'gold':
      packIcon = 'far fa-crown'
      break

    case 'platinum':
      packIcon = 'far fa-ring'
      break

    case 'diamond':
      packIcon = 'far fa-gem'
      break
  }
  return packIcon
}

const getStatusIcon = (status) => {
  let statusIcon
  switch (status) {
    case 'paused':
      statusIcon = 'fas fa-pause'
      break

    case 'completed':
      statusIcon = 'fas fa-flag-checkered'
      break

    case 'modified':
      statusIcon = 'far fa-edit'
      break

    default:
      statusIcon = ''
      break
  }
  return statusIcon
}

const formatDate = (date, arg) => {
  const toFormat = new Date(date)

  return toFormat
    .toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      ...arg,
    })
    .replace(/ /g, ' ')
}

const timeToCSS = (miliseconds) => {
  return ((miliseconds % 60000) / 1000).toFixed(2)
}

const getTimeType = (date) => {
  if (!date) return 'No date provided'
  const today = new Date()
  const passedDate = new Date(date)
  const difference = today.getTime() - passedDate.getTime()
  const dayPassed = difference / (1000 * 3600 * 24)
  const hours = parseInt(difference / (1000 * 3600))
  const minutes = parseInt(new Date(difference).getMinutes())

  if (dayPassed >= 1) {
    return { type: 'day', passedDate }
  } else if (hours) {
    return { type: 'hour', hours }
  } else {
    return { type: 'minutes', minutes }
  }
}

const getTimeLimit = (dateLimit) => {
  if (!dateLimit) return
  const today = new Date()

  let diffInMilliSeconds = Math.floor(new Date(dateLimit) - today) / 1000

  diffInMilliSeconds = diffInMilliSeconds < 0 ? 0 : diffInMilliSeconds
  // calculate hours
  let hours = Math.floor(diffInMilliSeconds / 3600) % 24
  diffInMilliSeconds -= hours * 3600

  // calculate minutes
  let minutes = Math.floor(diffInMilliSeconds / 60) % 60
  diffInMilliSeconds -= minutes * 60

  const difference = hours > 0 ? { time: hours, type: 'hours' } : { time: minutes, type: 'minutes' }

  return difference
}

const categorize = (array, category) => {
  return array.reduce((acc, value) => ((acc[category(value)] ||= []).push(value), acc), {})
}

const sortObject = (object) => {
  return Object.keys(object)
    .sort()
    .reduce((prop, key) => ((prop[key] = object[key]), prop), {})
}

const setObjectKeys = (object, extraParams) => {
  const toUpdate = Object.keys(object)
  return {
    keys: toUpdate,
    ...object,
    ...extraParams,
  }
}

const buildURL = (type, { id = 'Need an id', title = 'Need a title' }) => {
  const baseURL = 'http://localhost:8080/'
  const formatedTitle = slugify(title)

  switch (type) {
    case 'card':
      return `${baseURL}c/${id}/${formatedTitle}`
    case 'template':
      return `${baseURL}t/${id}/${formatedTitle}`
  }
}

const slugify = (string) => {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

const checkApiResponse = (response) => {
  return response?.status >= 200 && response?.status <= 299
}

// const setCordsPosition = (element, parent, position) => {
//   const cords = parent.getBoundingClientRect()
//   const x = cords.x
//   const y = cords.y
//   const w = cords.width
//   const h = cords.height
//   const style = element.style
//   const scrollTop = window.pageYOffset
//   const elTop = element.clientHeight + cords.y + scrollTop
//   const rootTop = scrollTop + window.innerHeight

//   if (
//     x + w + 10 + element.getBoundingClientRect().width > window.innerWidth &&
//     position == 'right'
//   ) {
//     position = 'left'
//     element.classList.remove('right')
//     element.classList.add('left')
//   }

//   if (x - 10 < element.getBoundingClientRect().width && position == 'left') {
//     position = 'top'
//     element.classList.remove('left')
//     element.classList.add('top')
//   }

//   if (rootTop - elTop < 30 || position == 'top') {
//     // console.log('hola mundo')
//     style.top = `${y + scrollTop - element.clientHeight - 8}px`
//     const left = x + (w - element.getBoundingClientRect().width) / 2

//     if (left + element.getBoundingClientRect().width < window.innerWidth) {
//       if (left > 0) {
//         style.left = `${left}px`
//       } else {
//         style.left = '10px'
//         element.classList.add('notArrow')
//       }
//     } else {
//       style.left = 'auto'
//       style.right = '10px'
//       element.classList.add('notArrow')
//     }
//   } else if (position == 'bottom') {
//     style.top = `${y + scrollTop + h + 8}px`
//     const left = x + (w - element.getBoundingClientRect().width) / 2

//     if (left + element.getBoundingClientRect().width < window.innerWidth) {
//       if (left > 0) {
//         style.left = `${left}px`
//       } else {
//         style.left = '10px'
//         element.classList.add('notArrow')
//       }
//     } else {
//       style.left = 'auto'
//       style.right = '10px'
//       element.classList.add('notArrow')
//     }
//   } else if (position == 'left') {
//     style.top = `${y + scrollTop + (h - element.getBoundingClientRect().height) / 2}px`
//     style.left = `${x - element.getBoundingClientRect().width - 8}px`
//   } else if (position == 'right') {
//     style.top = `${y + scrollTop + (h - element.getBoundingClientRect().height) / 2}px`
//     style.left = `${x + w + 8}px`
//   }
// }

/**
 * Sroll To Element
 *
 * @param {String} selector CSS selector target
 * @param {String} scrollableSelector CSS selector scrollable element
 * @param {Number} scrollOffset The offset of the scroll in case of adjusting
 */
const scrollToElement = (selector, scrollableSelector, scrollOffset = 0) => {
  const target = document.querySelector(selector)
  const scrollable = document.querySelector(scrollableSelector)

  const options = {
    top: target.offsetTop - scrollOffset,
    behavior: 'smooth',
  }
  scrollable.scrollTo(options)
}

const insertBody = (element, parent = null) => {
  const target = parent ? parent : document.body
  if (!(element instanceof Node)) return false
  target.insertBefore(element, target.lastChild)
  return true
}

const removeBody = (element, parent = null) => {
  const target = parent ? parent : document.body
  target.removeChild(element)
}

const missClicked = () => {
  if (window.getSelection().type === 'Range') return true
  return false
}

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  let isInViewport =
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  return isInViewport
}

const viewportIntersect = (callback, element) => {
  const observer = new IntersectionObserver(callback, {
    root: null,
    threshold: 1.0,
  })

  observer.observe(element)
}

// exporting functions
export {
  slugify,
  buildURL,
  timeToCSS,
  insertBody,
  removeBody,
  categorize,
  sortObject,
  formatDate,
  checkArray,
  getTimeType,
  missClicked,
  formatTitle,
  getPackIcon,
  filterCards,
  getSlotClass,
  getTimeLimit,
  isInViewport,
  getStatusIcon,
  setObjectKeys,
  calculateOrder,
  setDriveFolder,
  scrollToElement,
  checkApiResponse,
  // setCordsPosition,
  viewportIntersect,
  getComputedStyles,
  ToNextElementOrder,
  getRandomArbitrary,
  filterCardsByStatus,
  arraySortByObjectKey,
  sortArrayByObjectKey,
  filterElementsByQuery,
  removeArrayDuplicates,
  objectHasPropertyValue,
}
